import React from "react";
// import image1 from "../../images/aboutslush.png";
import image2 from "../../images/WW-Hero-1.jpg";
import { Helmet } from "react-helmet";

import styles from "./index.module.css";

export default function SupportPage() {
	return (
		<div className={styles.SupportPage}>
			<Helmet>
				<title>Wet Willie's Franchise | Support</title>
			</Helmet>
			<div className={styles.figureContainer}>
				<figure>
					<img src={image2} alt="hero" />
				</figure>
			</div>
			<div className={styles.header}>
				<h1>SUPPORT</h1>
			</div>
			<div className={styles.articleContainer}>
				<article>
					<section className={styles.section2}>
						<h2>PRIOR TO OPENING</h2>
						<ol>
							<li>
								Criteria for use in selecting a site for your
								Wet Willie's,
							</li>
							<li>Review of your draft architectural drawings</li>
							<li>
								We will provide your architect or general
								contractor information about the sequence of
								events and procedures that must be followed in
								building out and equipping a Wet Willie's
							</li>
							<li>
								We will provide 2 construction visits to the
								site by a designated construction advisor
							</li>
							<li>
								Criteria for signage (Franchise Agreement,
								Section 4).
								<ul>
									<li>
										<span>•</span>
										Approval of your site and your lease of
										the premises.
									</li>
									<li>
										<span>•</span>
										Lists of the inventory, merchandise,
										supplies, computer hardware, software,
										communications devices and equipment and
										other items needed to stock and operate
										the Wet Willie's, together with the
										names of any suppliers we have
										designated or approved, as well as
										recorded music for use at the premises
									</li>
									<li>
										<span>•</span>
										Training to you or your Operating
										Principal and your Manager, as described
										below
									</li>
									<li>
										<span>•</span>A copy of our
										Operations/Training Manual
									</li>
									<li>
										<span>•</span>
										Opening assistance, including on-site
										pre-opening and opening training,
										supervision and assistance to you
									</li>
								</ul>
							</li>
						</ol>
						<h2>TRAINING PROGRAM</h2>
						<p>
							Before opening your Wet Willie's, you, your
							Operating Principal and your Manager must complete,
							to our satisfaction, an 8-week initial training
							program we conduct. You, your Operating Principal
							and your Manager must have successfully completed
							all state and local required food hygiene and
							sanitation training as well as having completed a
							certified course for responsible alcohol service
							before attending our training program.
							<br />
							<br />
							We will provide up to 10 days of on-site training
							for all of your other full and part-time hourly
							employees and members of your staff. We will not
							charge you a fee for the training of your first
							Manager and your initial staff. We may charge you a
							fee for any additional required or optional training
							and training for subsequent staff. All training will
							be provided at a location we designate. You must pay
							for your employees' travel expenses and room, board,
							wages and insurance during training.
						</p>
						<br />
						<p>
							The initial training program for you, your Operating
							Principal and your Manager, which lasts 8 weeks, is
							conducted at our headquarters located in Savannah,
							Georgia or at a different location if you and we
							agree on it. Our training program is overseen by
							William Dickinson whose experience is listed in Item
							2 of this disclosure document. Any other individuals
							involved in the training program will have at least
							one year of experience in the subject they teach.
						</p>
						<br />
						<p>An outline of the initial training is as follows:</p>
						<div className={styles.table}>
							<table>
								<tr>
									<th>Subject</th>
									<th>Classroom Hours</th>
									<th>Hands On Hours</th>
									<th>Location</th>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Introductions, Orientation
									</td>
									<td>2</td>
									<td></td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Policies & Procedures For Employees
									</td>
									<td>2</td>
									<td></td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Manager Training Program
									</td>
									<td>16</td>
									<td></td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Bartender/Server Training Manual
									</td>
									<td>2</td>
									<td></td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Kitchen Staff Training Manual
									</td>
									<td>2</td>
									<td></td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Door Staff Training Manual
									</td>
									<td>2</td>
									<td></td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Barback & Mixing Training Manual
									</td>
									<td>2</td>
									<td></td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Week Review & Discussion
									</td>
									<td>2</td>
									<td></td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Kitchen Training
									</td>
									<td></td>
									<td>80</td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Barback & Mixing Training
									</td>
									<td></td>
									<td>20</td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Bartender Training
									</td>
									<td></td>
									<td>20</td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Door Staff Training
									</td>
									<td></td>
									<td>20</td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td className={styles.tableTitle}>
										Manager Training
									</td>
									<td></td>
									<td>130</td>
									<td>Our Headquarters</td>
								</tr>
								<tr>
									<td>TOTALS</td>
									<td>30</td>
									<td>290</td>
									<td>
										Our Headquarters in <br /> Savannah,
										Georgia
									</td>
								</tr>
							</table>
						</div>
						<h2>Support During Operation</h2>
						<p>
							After you open your Wet Willie's, we will provide
							the following assistance and services to you:
						</p>
						<br />
						<ul>
							<li>
								<span>•</span>
								Our staff will be accessible to you and your
								staff for consultation by telephone, fax,
								written communication, e-mail and other forms of
								electronic communication.
							</li>
							<li>
								<span>•</span>
								We will visit your Wet Willie's location from
								time to time to conduct quality reviews and to
								consult with the staff regarding Standards of
								Quality and Performance Compliance.
							</li>
							<li>
								<span>•</span>
								We will host refresher training sessions for
								franchisees at franchisee conferences and
								conventions.
							</li>
							<li>
								<span>•</span>
								We will develop and provide additions and
								supplements to the Operations Manual as they
								become available
							</li>
							<li>
								<span>•</span>Marketing materials
							</li>
							<li>
								<span>•</span>Operation of a Brand Fund
							</li>
							<li>
								<span>•</span>Access to our intranet site
							</li>
							<li>
								<span>•</span>Hosting a web page for you on our
								website.
							</li>
							<li>
								<span>•</span>
								Evaluation of proposed modifications to our
								approved suppliers and products.
							</li>
							<li>
								<span>•</span>
								Access to our approved supplier network and the
								ability to take advantage of our buying power.
							</li>
						</ul>
						<br />
					</section>
				</article>
			</div>
		</div>
	);
}
